// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MembersPanelHeader__container-edfb39 {
  display: flex;
  padding: 12px 16px;
  align-items: center;
  min-height: 72px;
  box-sizing: border-box;
}

.MembersPanelHeader__icon-ccf25d {
  margin-inline-end: var(--indent-16px);
}

.MembersPanelHeader__content-f75014 {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.MembersPanelHeader__title-e12b4e {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--addition-50);
  opacity: 0.7;
}

.MembersPanelHeader__description-b81ddf {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/GroupVideoCall/MembersPanel/MembersPanelHeader/MembersPanelHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  padding: 12px 16px;\n  align-items: center;\n  min-height: 72px;\n  box-sizing: border-box;\n}\n\n.icon {\n  margin-inline-end: var(--indent-16px);\n}\n\n.content {\n  flex: 1 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.title {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--addition-50);\n  opacity: 0.7;\n}\n\n.description {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MembersPanelHeader__container-edfb39`,
	"icon": `MembersPanelHeader__icon-ccf25d`,
	"content": `MembersPanelHeader__content-f75014`,
	"title": `MembersPanelHeader__title-e12b4e`,
	"description": `MembersPanelHeader__description-b81ddf`
};
module.exports = ___CSS_LOADER_EXPORT___;
